import { useContext } from "react";
import { ProcessContext } from "../../../../../../../../../../contexts/ProcessContext";

export const usePaymentGateway = (paymentPlanLineId) => {
  const {
    state: { paymentToken },
    dispatch,
  } = useContext(ProcessContext);

  const getPaymentTokenByPaymentPlanLineId = () => {
    dispatch({
      type: "REQUEST_GET_TOKEN_BY_PAYMENT_LINE_ID",
      payload: paymentPlanLineId,
    });
  };

  return { paymentToken, getPaymentTokenByPaymentPlanLineId };
};
